import Dependencies from '../utilities/dependencies';

export default class Header {

	/**
	 * CSS selectors that must exist for this module to run
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getHolderSelectors = () => ['.header'];

	/**
	 * Dependencies that this module requires
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getDependencies = () => [Dependencies.libraries.jQuery];

	/**
	 * Runtime injected CSS classes
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getClassList = () => Object.create({});

	/** @type {HTMLElement} */
	#holderElement;

	/**
	 * @param {HTMLElement} holderElement
	 */
	constructor(holderElement) {
		this.#holderElement = holderElement;
		let self = this,
			navigationBookNowBtn = this.#holderElement.querySelector('.book-now-link'),
			bookingFormContainer = this.#holderElement.querySelector('.booking-form-container'),
			toggleHeader = this.#holderElement.querySelector('.js-toggle-menu'),
			menu = this.#holderElement.querySelector('#menu'),
			toggleBooking = this.#holderElement.querySelector('.js-toggle-booking'),
			bookingForm = this.#holderElement.querySelector('.booking-form-widget');

		window.addEventListener('scroll', function() {
			let scrollFromTop = document.documentElement.scrollTop || document.body.scrollTop;

			if (scrollFromTop >= 10)
				self.#holderElement.classList.add('is-sticky');

			else
				self.#holderElement.classList.remove('is-sticky');
		});

		// if (navigationBookNowBtn) {
		// 	navigationBookNowBtn.addEventListener('click', function() {
		// 		event.preventDefault();
		// 		bookingFormContainer.classList.toggle('show');
		// 	});
		// }

		toggleHeader.addEventListener('click', function() {
			toggleHeader.classList.toggle('show');
			menu.classList.toggle('show');
		});

		toggleBooking && toggleBooking.addEventListener('click', function() {
			toggleBooking.classList.toggle('show');
			bookingForm.classList.toggle('show');
			bookingFormContainer.classList.toggle('show');
			toggleHeader.classList.remove('show');
			menu.classList.remove('show');
		});

		// window.addEventListener('click', function(event) {
		// 	if (event.target !== navigationBookNowBtn && event.target !== toggleBooking && bookingFormContainer.classList.contains('show')) {
		// 		if (!bookingFormContainer.contains(event.target)) {
		// 			toggleBooking.click();
		// 		}
		// 	}
		// });

		// Smooth scrolling
		// window.addEventListener('click', 'a[href^="#"]', function() {
		// 	event.preventDefault();
		//
		// 	document.body.animate({
		// 		scrollTop: $($.attr(this, 'href')).offset().top
		// 	}, 500);
		// });
	}
}
